import React, { useRef, useState } from 'react';
import { TextInput, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { useForm } from 'react-hook-form';
import CustomButton from '../../components/CustomButton';
import { translate } from '../../services/translate';
import RtcMediaPlayer, { ConnectionState, RtcMediaPlayerRef } from '../../components/RtcMediaPlayer';
import Toast from 'react-native-toast-message';
import MyAppText from '../../components/MyAppText';

interface ConsumerForm {
    url: string;
}

export default function Consumer() {
    const { styles } = useStyles(styleSheet);

    const rtcRef = useRef<RtcMediaPlayerRef>(null);
    const [connectionState, setConnectionState] = useState<ConnectionState>();

    const defaultEmptyValues: ConsumerForm = {
        url: 'https://srs000009.stage-webrtc-servers.stage.sentinelx.com.br/rtc/v1/whep/?app=live&stream=pwa',
    };

    const form = useForm<ConsumerForm>({
        defaultValues: defaultEmptyValues,
    });

    async function consume() {
        try {
            const values = form.getValues();
            const data = await rtcRef.current?.consume(values);

            console.log(data);

            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });
        } catch (err) {
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    return <View style={styles.container}>
        <View style={styles.headerContent}>
            <View style={{ flex: 1 }}>
                <TextInput
                    style={[styles.textInput, styles.textColor(form.watch('url'))]}
                    value={form.watch('url')}
                    onChangeText={value => form.setValue('url', value)}
                    placeholder={'URL'}
                />
            </View>
            <CustomButton
                onPress={consume}
                text={translate('consume')}
            />
        </View>
        <View style={styles.cardList}>
            <MyAppText>State: {connectionState}</MyAppText>
            <RtcMediaPlayer
                ref={rtcRef}
                setConnectionState={setConnectionState}
            />
        </View>
    </View>;
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flex: 1,
    },
    label: {
        fontSize: 16,
        height: 25,
    },
    textInput: {
        fontFamily: 'Open Sans',
        backgroundColor: theme.colors.container.background,
        borderWidth: 1,
        borderRadius: 4,
        borderColor: theme.colors.container.border,
        height: 40,
        minHeight: 40,
        fontSize: 16,
        padding: 10
    },
    textColor: (text?: string) => ({
        color: text ? theme.colors.field.text : theme.colors.disabledText
    }),
    headerContent: {
        flexDirection: 'row',
        minHeight: 65,
        zIndex: 2,
        flexWrap: 'wrap',
        gap: 15,
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    cardList: {
        borderWidth: 1,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        borderColor: theme.colors.container.border,
        backgroundColor: theme.colors.container.background,
        paddingHorizontal: 10,
        flex: 1
    },
}));
